import React from "react";
import UserService from "rc-app/services/UserService";
import LandingPage from "rc-app/Pages/LandingPage";
import LoginPage from "rc-app/Pages/LoginPage";
import ResetPasswordPage from "rc-app/Pages/ResetPasswordPage";
import Builders from "rc-app/Pages/Builders";
import ProductPage from "rc-app/Pages/ProductPage";
import Pricing from "rc-app/Pages/Pricing";
import { PrivacyPolicy } from "rc-app/Pages/PrivacyPolicy";
import { TermsOfUse } from "rc-app/Pages/TermsOfUse";
import { isPublicPath } from "rc-app/utils/publicRoutes";

const RenderOnAnonymous = () => {
  const path = window.location.pathname;
  if (path === "/reset-password") return <ResetPasswordPage />;
  if (UserService.isLoggedIn()) return null;
  if (path === "/login") return <LoginPage />;
  if (path === "/builders") return <Builders />;
  if (path === "/product") return <ProductPage />;
  if (path === "/pricing") return <Pricing />;
  if (path === "/privacy_policy") return <PrivacyPolicy />;
  if (path === "/terms_and_conditions") return <TermsOfUse />;
  // Public routes — an anonymous visitor belongs here, so do NOT show the
  // landing page. Return null and let RenderOnAuthenticated render the route
  // (its auth gate reads the SAME list, and the two must agree — see
  // utils/publicRoutes for what happens when they don't).
  if (isPublicPath(path, window.location.search)) return null;
  return <LandingPage />;
};

export default RenderOnAnonymous;
